import React from 'react';
import WrappedBase from './WrappedBase';

import CommitmentUpsellModal from '../containers/CommitmentUpsellModal';

export default class CommitmentUpsellModalWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <CommitmentUpsellModal {...this.props} />
      </WrappedBase>
    );
  }
}
